import { useSignals } from '@preact/signals-react/runtime'
import { NameEntryFormUI } from '../NameEntryFormUI/NameEntryFormUI'
import type { LocalMates } from '../../../../deps/localMates/localMates/localMates.types'

interface NameEntryFormProps {
  localMates: LocalMates
}

export function NameEntryForm({ localMates }: NameEntryFormProps) {
  useSignals()

  return (
    <NameEntryFormUI
      mateName={localMates.tempName.value}
      error={''}
      onNameChange={(name) => localMates.tempName.value = name}
      onSubmit={() => localMates.saveTempName()}
    />
  )
}
